/**
 * @generated SignedSource<<5476e48a60c8d601aafb3f8d96e55167>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClipsPanel_DeleteClipModal_clip$data = {
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "ClipsPanel_DeleteClipModal_clip";
};
export type ClipsPanel_DeleteClipModal_clip$key = {
  readonly " $data"?: ClipsPanel_DeleteClipModal_clip$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClipsPanel_DeleteClipModal_clip">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClipsPanel_DeleteClipModal_clip",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "MeetingRecordingClip",
  "abstractKey": null
};

(node as any).hash = "c6ce5628e08436965f93663a442c9d9f";

export default node;
